(() => {
  if (window.__szhUnifiedProductCards) return;
  window.__szhUnifiedProductCards = true;

  const sectionSelector = '.section-szh-collection-product-grid, .section-szh-search-results';
  const cardSelector = [
    '.section-szh-collection-product-grid .product-card:not(.card--horizontal)',
    '.section-szh-search-results .szh-search-grid-card .product-card:not(.card--horizontal)'
  ].join(', ');
  const dynamicPriceSelector = '[id^="am-omnibus-container-"]';
  let frame = 0;
  let resizeTimer = 0;

  const updateInventoryText = (container) => {
    const badge = container.querySelector('.product__inventory--pill');
    if (!badge) return;
    const node = Array.from(badge.childNodes).find((item) => item.nodeType === 3 && /\d+/.test(item.textContent));
    const match = node?.textContent.match(/\d+/);
    if (!match) return;
    const qty = Number(match[0]);
    if (qty === 1) node.textContent = 'Pozostała tylko 1 sztuka';
    else if (qty >= 2 && qty <= 4) node.textContent = 'Pozostały tylko ' + qty + ' sztuki';
    else if (qty >= 5 && qty <= 10) node.textContent = 'Pozostało tylko ' + qty + ' sztuk';
  };

  const ensureSearchInventory = (card) => {
    if (!card.closest('.section-szh-search-results')) return;
    const media = card.querySelector(':scope > .card__inner');
    card.querySelectorAll('.card-inventory-container').forEach((container) => {
      updateInventoryText(container);
      if (media && container.parentElement !== media) media.appendChild(container);
    });
  };

  const ensureRatingSlot = (card) => {
    const information = card.querySelector(':scope > .card__content > .card__information');
    const heading = information?.querySelector(':scope > .card__heading');
    if (!heading) return;

    let slot = information.querySelector(':scope > .product-card-rating-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'product-card-rating-slot';
    }
    if (heading.previousElementSibling !== slot) {
      heading.insertAdjacentElement('beforebegin', slot);
    }

    const wrappers = information.querySelectorAll('.etrusted-card-rating');
    wrappers.forEach((wrapper) => {
      if (!slot.contains(wrapper)) slot.appendChild(wrapper);
    });
    const widgets = information.querySelectorAll('etrusted-widget[data-sku]');
    widgets.forEach((widget) => {
      if (slot.contains(widget)) return;
      const wrapper = widget.closest('.etrusted-card-rating');
      if (wrapper && !slot.contains(wrapper)) slot.appendChild(wrapper);
      else if (!wrapper) slot.appendChild(widget);
    });
  };

  const ensurePurchaseArea = (card) => {
    const content = card.querySelector(':scope > .card__content');
    const cardInfo = content?.querySelector(':scope > .card__information > .card-information');
    const price = cardInfo?.querySelector(':scope > .price');
    const quickAdd = cardInfo?.querySelector(':scope > .quick-add') ||
      content?.querySelector(':scope > .quick-add');
    if (!price || !quickAdd) return;
    quickAdd.classList.remove('pt-15');
    if (quickAdd.parentElement !== cardInfo || price.nextElementSibling !== quickAdd) {
      price.insertAdjacentElement('afterend', quickAdd);
    }
  };

  const normalizeDynamicPrice = (card) => {
    card.querySelectorAll(dynamicPriceSelector).forEach((element) => {
      element.style.setProperty('height', 'auto', 'important');
      element.style.setProperty('min-height', '0', 'important');
      element.style.setProperty('margin', '0.2rem 0 0', 'important');
      element.style.setProperty('padding', '0', 'important');
      element.querySelectorAll('*').forEach((child) => {
        child.style.setProperty('min-height', '0', 'important');
        child.style.setProperty('margin-block-start', '0', 'important');
        child.style.setProperty('margin-block-end', '0', 'important');
        child.style.setProperty('padding-block-start', '0', 'important');
        child.style.setProperty('padding-block-end', '0', 'important');
      });
    });
  };

  const visibleCards = (section) => Array.from(section.querySelectorAll(cardSelector))
    .filter((card) => card.getClientRects().length > 0 && card.offsetParent !== null);

  const equalizeRowSlots = (section) => {
    const cards = visibleCards(section);
    if (!cards.length) return;
    cards.forEach((card) => {
      card.style.removeProperty('--product-card-title-slot-height');
      card.style.removeProperty('--product-card-price-slot-height');
    });

    const rows = [];
    cards.forEach((card) => {
      const item = card.closest('.grid__item');
      const top = item ? item.getBoundingClientRect().top : card.getBoundingClientRect().top;
      let row = rows.find((entry) => Math.abs(entry.top - top) <= 2);
      if (!row) {
        row = { top, cards: [] };
        rows.push(row);
      }
      row.cards.push(card);
    });

    const rootSize = Number.parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
    const minPriceHeight = rootSize * 6.2;
    rows.forEach((row) => {
      let maxTitle = 0;
      let maxPrice = minPriceHeight;
      row.cards.forEach((card) => {
        const title = card.querySelector('.card__heading');
        const price = card.querySelector('.card-information > .price');
        if (title) maxTitle = Math.max(maxTitle, Math.ceil(title.scrollHeight));
        if (price) maxPrice = Math.max(maxPrice, Math.ceil(price.scrollHeight));
      });
      row.cards.forEach((card) => {
        if (maxTitle) card.style.setProperty('--product-card-title-slot-height', maxTitle + 'px');
        card.style.setProperty('--product-card-price-slot-height', Math.ceil(maxPrice) + 'px');
      });
    });
  };

  const refresh = () => {
    frame = 0;
    document.querySelectorAll(sectionSelector).forEach((section) => {
      section.querySelectorAll(cardSelector).forEach((card) => {
        if (card.dataset.szhCardOrder !== 'listing') {
          ensureSearchInventory(card);
          ensureRatingSlot(card);
          ensurePurchaseArea(card);
        }
        normalizeDynamicPrice(card);
      });
      equalizeRowSlots(section);
    });
  };

  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => requestAnimationFrame(refresh));
  };

  const init = () => {
    refresh();
    const main = document.getElementById('MainContent') || document.documentElement;
    new MutationObserver((records) => {
      const affectsCards = records.some((record) => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return target?.closest?.(sectionSelector) != null ||
          Array.from(record.addedNodes).some((node) =>
            node.nodeType === 1 && (node.matches?.(sectionSelector) || node.querySelector?.(sectionSelector))
          );
      });
      if (affectsCards) schedule();
    }).observe(main, { childList: true, subtree: true });

    document.addEventListener('collection:products-updated', schedule);
    document.addEventListener('am:omnibus:loaded', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('.section-szh-search-results [data-szh-view-button]') ||
          event.target.closest?.('.section-szh-collection-product-grid [data-szh-view-button]')) schedule();
    });
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(schedule, 120);
    }, { passive: true });
    if (document.fonts?.ready) document.fonts.ready.then(schedule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

